import { CheckIcon, TruckIcon } from '@/components/Icons';
import { memo } from 'react';

interface IProps {
  borderDashed?: boolean;
  borderColor?: string;
  backgroundColor?: string;
  iconColor?: string;
  text: string;
  isSelected?: boolean;
  handleClick: () => void;
}

const TemplateCard = ({ text, backgroundColor, borderColor, borderDashed, iconColor, isSelected, handleClick }: IProps) => {
  return (
    <div
      className="content-between align-center"
      style={{
        border: `1px ${borderDashed ? 'dashed' : 'solid'} ${
          borderColor && borderColor !== 'transparent' && borderColor !== '#ffffff' ? borderColor : '#eeeeee'
        }`,
        backgroundColor: backgroundColor || '#ffffff',
        borderRadius: 'var(--p-border-radius-200)',
        padding: 'var(--p-space-150) var(--p-space-300)',
        cursor: 'pointer',
      }}
      onClick={handleClick}
    >
      <div className="d-flex align-center">
        <span className="mr-8" style={{ height: 16 }}>
          <TruckIcon fill={iconColor} />
        </span>
        <span>{text}</span>
      </div>
      <div className="d-flex align-center">{isSelected ? <CheckIcon /> : null}</div>
    </div>
  );
};

export default memo(TemplateCard);
